// src/pages/Proposals/FileDialog/forms/common/BeamlineSelect.js
import React from "react";
import PropTypes from "prop-types";
import EntitySelect from "../common/EntitySelect";

function BeamlineSelect({
  value,
  onChange,
  infrastructure,
  label = "beamline",
  sx,
  required = false,
  error = false,
  helperText = "",
}) {
  // console.log("VALUE:", value);
  const endpoint =
    infrastructure != null && infrastructure !== ""
      ? `/beamline/?infrastructure=${infrastructure}`
      : null;
  return (
    <EntitySelect
      multiple
      value={value}
      onChange={onChange}
      endpoint={endpoint}
      label={label}
      getOptionLabel={(opt) => opt?.name || ""}
      searchParam="search"
      sx={sx}
      error={error}
      helperText={helperText}
    />
  );
}
BeamlineSelect.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.oneOf([null]),
  ]),
  onChange: PropTypes.func.isRequired,
  infrastructure: PropTypes.number,
  label: PropTypes.string,
  sx: PropTypes.object,
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
};
BeamlineSelect.defaultProps = {
  value: [],
  infrastructure: null,
  label: "beamline",
  sx: {},
  required: false,
  error: false,
  helperText: "",
};

export default React.memo(BeamlineSelect);
